import React, {createRef, useEffect, useState} from 'react';
import './button.css'
import useIsMountedRef from "../../utils/mountedRef";


const ButtonTVA = (props) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const isMountedRef = useIsMountedRef();

    const refYes = createRef();
    const refNo = createRef();

    function EventClick(refPassed, value) {

        refPassed.current.classList.remove("item_no_selected");

        if (refPassed !== refYes) {
            refYes.current.classList.remove('item_selected')
            refYes.current.classList.add('item_no_selected')
        }

        if (refPassed !== refNo) {
            refNo.current.classList.remove('item_selected')
            refNo.current.classList.add('item_no_selected')
        }

        refPassed.current.classList.add('item_selected')

        setSelectedValue(value);
        refPassed.current.focus();
        if (value === 0){
            props.handleChange(props.setter, 0.055)
        } else if (value === 1) {
            props.handleChange(props.setter, 0.2)
        }
         // launch handleChange in parent simu
    }
    const handleKeyDown = (e, currentIndex) => {
    const buttons = [refYes, refNo]; 
        if (e.key === "ArrowRight") {
            e.preventDefault();
            if (currentIndex < buttons.length - 1) {
                const next = buttons[currentIndex + 1];
                next.current.focus();
                EventClick(next, parseInt(next.current.dataset.value));
            }
        } 
        else if (e.key === "ArrowLeft") {
            e.preventDefault();
            if (currentIndex > 0) {
                const prev = buttons[currentIndex - 1];
                prev.current.focus();
                EventClick(prev, parseInt(prev.current.dataset.value));
            }
        }
    };


    useEffect(() => {
        switch (props.defaultValue) {
            case 1:
                EventClick(refYes, 1);
                break;
            case 0:
                EventClick(refNo, 0);
                break;
            default:
                break;
        }
    }, [isMountedRef]);

    return (
        <div className={"item_ctn"}>
            <div data-value="1" className={"droitpartage item_no_selected"} ref={refYes} 
            tabIndex={selectedValue === 1 ? 0 : -1}
            onClick={((e) => {
                EventClick(refYes, 1)
            })}
            onKeyDown={(e)=> handleKeyDown(e, 0)}
            >
                20%
            </div>

            <div data-value="0" className={"droitpartage item_no_selected"} ref={refNo} 
            tabIndex={selectedValue === 0 ? 0 : -1}
            onClick={((e) => {
                EventClick(refNo, 0)
            })}
            onKeyDown={(e)=> handleKeyDown(e, 1)}>
                5,5%
            </div>
            
        </div>
    );
};

export default ButtonTVA;
